import { Wrapper } from '@american-autonomy/ag-ui';

import EntitySelectPillButton from 'components/EntitySelectPillButton';
import WithField from 'components/WithField';
import BoundarySelectPanelField from 'components/fields/BoundarySelectPanelField';

import useData from './hooks/useData';
import useTranslation from './hooks/useTranslation';

import { TEST_ID } from './constants';
import type { FieldValues, Props } from './types';

import styles from './styles.module.scss';

const SelectBoundaryField = <T extends FieldValues>(props: Props<T>) => {
    const {
        className = '',
        control,
        isOpen,
        isRequired,
        label,
        name,
        onPanelClose,
        onPanelOpen,
        placeholder,
        ref,
        siteId = '',
        testId = TEST_ID
    } = props;

    const { BOUNDARY } = useTranslation();

    const { containerRef, handleClose, handleToggle, isPanelOpen, onChange, value } = useData<T>({
        control,
        isOpen,
        isRequired,
        name,
        onPanelClose,
        onPanelOpen,
        ref
    });

    const fieldLabel = label ?? BOUNDARY;

    return (
        <Wrapper
            className={`${styles.wrapper} ${isPanelOpen ? styles.panelOpen : ''} ${className}`}
            ref={containerRef}
            testId={testId}>
            <WithField className={styles.withField} label={fieldLabel}>
                <EntitySelectPillButton
                    hasValue={!!value}
                    onClick={handleToggle}
                    onRemove={() => onChange(null)}
                    text={value?.label ?? placeholder ?? BOUNDARY}
                />
            </WithField>

            {isPanelOpen && (
                <BoundarySelectPanelField
                    onChange={onChange}
                    onClose={handleClose}
                    siteId={siteId}
                    value={value}
                />
            )}
        </Wrapper>
    );
};

export default SelectBoundaryField;
